/** Fetch Catalog rows for one vendor (exec-gated data — callers must
 *  only invoke when hasExecAccess; a non-exec token gets Unauthorized, which
 *  we THROW so the view can show an error instead of an empty catalog). */
import { generateClient } from 'aws-amplify/api';
import { listCatalogComponents, listCatalogCompositions } from '../graphql/catalogOps';

async function drain(client, query, field, filter) {
  const items = [];
  let nextToken = null;
  do {
    const res = await client.graphql({ query, variables: { filter, limit: 1000, nextToken } });
    const pageData = res.data[field];
    items.push(...pageData.items);
    nextToken = pageData.nextToken;
  } while (nextToken);
  return items;
}

export async function fetchCatalogRows(vendor) {
  const client = generateClient();
  // No quarter filter: resolution needs earlier rows to carry forward.
  // Roughly 747 rows for AIC while the catalog is still dense (pre-task-6);
  // drops to 344 once rows are sparse.
  const components = await drain(client, listCatalogComponents, 'listCatalogComponents',
    { vendor: { eq: vendor } });
  const compositions = await drain(client, listCatalogCompositions, 'listCatalogCompositions',
    { vendor: { eq: vendor } });
  return { components, compositions };
}
